import React, { Component } from 'react';
import { Layout } from '$components/root';
import { connect } from 'react-redux';
import { hideAlert, hideNotification, submitPassword } from '$actions/root';

@connect(state => ({
  root: state.root.asMutable()
}), { hideNotification, hideAlert, submitPassword })
export default class RootRoute extends Component {
  componentWillReceiveProps(nextProps) {
    if (process.muhimma.indexOf(process.target[0]) !== -1) {
      document.title = `${nextProps.root.title && `${nextProps.root.title} »`} Muhimma`;
    } else {
      document.title = `${nextProps.root.title && `${nextProps.root.title} »`} Twentify`;
    }
  }

  render() {
    const { children, root, hideNotification, hideAlert, submitPassword } = this.props;
    const child = React.cloneElement(children, { root });
    if (root.alert) root.alert = { ...root.alert, onClose: hideAlert };

    return (
      <Layout
        loading={root.loading}
        passwordRequired={root.passwordRequired}
        onPasswordSubmit={submitPassword}
        notification={root.notification}
        alert={root.alert}
        onNotificationClose={hideNotification}>
        {child}
      </Layout>
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/root.js